import { ref } from 'vue'

const isOpen = ref(true)
const isMinimized = ref(false)

export function useSidebar() {
  const toggleSidebar = () => {
    isOpen.value = !isOpen.value
    if (isOpen.value) {
      isMinimized.value = false
    }
  }

  const toggleMinimize = () => {
    if (isOpen.value) {
      isMinimized.value = !isMinimized.value
    }
  }

  const closeSidebar = () => {
    isOpen.value = false
  }

  const openSidebar = () => {
    isOpen.value = true
  }

  return {
    isOpen,
    isMinimized,
    toggleSidebar,
    toggleMinimize,
    closeSidebar,
    openSidebar,
  }
}
